import { Dashboardconstant } from "./dashboardConstant";

const DashboardAction = {};

DashboardAction.getdashboardrevenue = ({
  vendor_id,
  model_id,
  station_id,
  manufacturer_id,
  from_date,
  to_date,
}) => ({
  type: Dashboardconstant.DASHBOARD_REVENUE_SAGA,
  payload: {
    vendor_id:vendor_id,
    model_id: model_id,
    station_id: station_id,
    manufacturer_id: manufacturer_id,
    from_date:from_date,
    to_date:to_date
  },
});

DashboardAction.getcustomer = ({ model_id, station_id, manufacturer_id , from_date,
  to_date,vendor_id}) => ({
  type: Dashboardconstant.CUSTOMERS_SAGA,
  payload: {
    vendor_id:vendor_id,
    model_id: model_id,
    station_id: station_id,
    manufacturer_id: manufacturer_id,
    from_date:from_date,
    to_date:to_date
  },
});

DashboardAction.gettimeconsumed = ({ model_id, station_id, manufacturer_id, from_date,
  to_date,vendor_id }) => ({

  type: Dashboardconstant.TIME_CONSUMED_SAGA,
  payload: {
    vendor_id:vendor_id,
    model_id: model_id,
    station_id: station_id,
    manufacturer_id: manufacturer_id,
    from_date:from_date,
    to_date:to_date
  },
 
});

DashboardAction.getpowerconsumed = ({ model_id, station_id, manufacturer_id, from_date,
  to_date,vendor_id }) => ({
  type: Dashboardconstant.POWER_CONSUMED_SAGA,
  payload: {
    vendor_id:vendor_id,
    model_id: model_id,
    station_id: station_id,
    manufacturer_id: manufacturer_id,
    from_date:from_date,
    to_date:to_date
  },
 
});

DashboardAction.getpopulartime = ({ model_id, station_id, manufacturer_id, from_date,
  to_date, vendor_id}) => ({
  type: Dashboardconstant.POPULAR_TIMES_SAGA,
  payload: {
    vendor_id:vendor_id,
    model_id: model_id,
    station_id: station_id,
    manufacturer_id: manufacturer_id,
    from_date:from_date,
    to_date:to_date
  },
 
});

export { DashboardAction };
